import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SaveReportAsCsvService {
  private urlReportRetrieve =
    environment.baseUrl + environment.api + 'reports/retrieve?fileTokens=';

  constructor(private http: HttpClient, private authService: AuthService) {}

  saveAsCSV(fileTokens) {
    return this.http
      .get(this.urlReportRetrieve + fileTokens + '&type=1', {
        headers: this.authService.getJwtAuthHeaders(),
        observe: 'response',
        responseType: 'arraybuffer',
      })
      .pipe(
        catchError(() => {
          return of();
        })
      );
  }
}
